import Janus, { JanusJS } from 'lib/janus';
import { logger } from 'utils/logger';
import { PublishingKind } from 'utils/webrtc/types';

export type JanusHandleKind = PublishingKind | 'videoroom-subscriber' | 'streaming-subscriber';

export const logJanusHandleAttached = (
  kind: JanusHandleKind,
  pluginHandle: JanusJS.PluginHandle,
  janus: Janus
) => {
  logger.remote({ system: true }).info('[media-server] handle attached', {
    handleId: pluginHandle.getId(),
    sessionId: janus.getSessionId(),
    kind,
  });
};
